import { useEffect, useState } from "react";

/**
 * A Date that refreshes every `intervalMs`, so time-based visibility re-evaluates
 * without a refetch.
 *
 * WHY: an appointments rail goes stale as the day passes, so cards must expire on
 * their own. Expiry is re-evaluated on this cheap local tick while the API refetch
 * stays far less frequent (Maria's answer #10).
 */
export const useMinuteTick = (intervalMs = 60_000): Date => {
	const [now, setNow] = useState<Date>(() => new Date());

	useEffect(() => {
		const interval = setInterval(() => setNow(new Date()), intervalMs);
		return () => clearInterval(interval);
	}, [intervalMs]);

	return now;
};
